<template>
  <div class="container default-container pt-5">
    <FilterOffers />
    <CityOffers class="mt-4" />
  </div>
</template>

<script>
// @ is an alias to /src
import CityOffers from '@/components/Home/CityOffers';
import FilterOffers from '@/components/Home/FilterOffers';

export default {
  name: 'Home',
  components: {
    CityOffers,
    FilterOffers,
  },
  metaInfo: {
    title: 'Ofertas de empleo',
    titleTemplate: '%s - ' + process.env.VUE_APP_NAME,
    meta: [
      { vmid: "description", name: "description", content: "Home page description" },
      { vmid: "og:title", name: "og:title", content: "Home" },
      { vmid: "og:description", name: "og:description", content: "Home page description" },
    ]
  },
}
</script>
